import React, { useId } from 'react';
import './SmsOptInCheckbox.css';

// Marketing-SMS opt-in checkbox (default unchecked). Carries the express-written-consent copy for
// short code 64526; the parent maps `checked` to marketing_sms_optout (checked => opt-out false).
export function SmsOptInCheckbox({ checked, onChange, labelClassName = '' }) {
    const id = useId();
    return (
        <label
            htmlFor={id}
            className={`d-flex align-items-start gap-2 mb-0 ${labelClassName}`.trim()}
            style={{ cursor: 'pointer' }}
        >
            <input type="checkbox" id={id} className="sms-optin-checkbox" checked={checked} onChange={onChange} />
            <small className="lh-base">
                By signing up for Milan Laser Alerts, you provide your express written consent to receive recurring
                marketing and promotional SMS messages from Milan Laser via short code 64526, including messages sent
                via automated equipment or using AI. Consent is not a condition of purchase. Message frequency varies.
                Message and data rates may apply. Reply STOP to opt out at any time, or reply HELP for help. I agree to{' '}
                <a
                    href="https://milanlaser.com/terms"
                    target="_blank"
                    rel="noreferrer"
                    className="text-decoration-underline fw-bold"
                >
                    Mobile Terms
                </a>{' '}
                and{' '}
                <a
                    href="https://milanlaser.com/privacy"
                    target="_blank"
                    rel="noreferrer"
                    className="text-decoration-underline fw-bold"
                >
                    Privacy Policy
                </a>
                . You can also contact customer support at{' '}
                <a href="tel:+18336672967" className="text-decoration-underline fw-bold">
                    1-833-667-2967
                </a>{' '}
                or email{' '}
                <a href="mailto:privacy@milanlaser.com" className="text-decoration-underline fw-bold">
                    privacy@milanlaser.com
                </a>
                . Carriers are not liable for delayed or undelivered messages.
            </small>
        </label>
    );
}

export default SmsOptInCheckbox;
